/**  Tailwind class sets — brand refresh footer (Epic 18767). Legacy when flag is off. */

export const FOOTER_LINK_LEGACY =
  'text-dryPink hover:bg-dark hover:bg-opacity-60 px-1 font-montserratMedium';

export const FOOTER_LINK_BR =
  'font-brandRefreshFellix text-brandRefresh-bodyLarge text-brandRefresh-surface-onSurface font-medium hover:opacity-80 px-0 bg-transparent focus-visible:outline focus-visible:outline-2 focus-visible:outline-brandRefresh-background-secondary focus-visible:outline-offset-2';

/** Shared yellow pill CTA — layout/typography in FooterBrandRefresh.module.css */
export const FOOTER_YELLOW_CTA_BR =
  'bg-brandRefresh-background-secondary cursor-pointer inline-flex items-center justify-center border-0 hover:opacity-90';

export const BR_SECTION_HEADING_CLASS = 'm-0';

export const getFooterContainerClass = (styles, br) =>
  br
    ? `${styles.footerContainer} w-full self-stretch flex flex-col`
    : `${styles.footerContainer} lg:grid grid-cols-5 flex flex-col gap-8`;

export const getFooterWrapperClass = (styles, br) =>
  br
    ? `${styles.footerWrapper} font-brandRefreshFellix bg-brandRefresh-background-primary text-brandRefresh-surface-onSurface`
    : `${styles.footerWrapper} bg-dark text-white block font-montserratMedium`;

export const getDealsSectionClass = (styles, br) =>
  br
    ? `${styles.sectionContainer} col-span-1 w-full`
    : `${styles.sectionContainer} col-span-1 flex flex-col items-center md:items-start md:justify-start justify-center gap-2 md:gap-8 md:text-left text-center`;

export const getDealsHeadingClass = (br) =>
  br ? BR_SECTION_HEADING_CLASS : 'text-lg leading-[22px] tracking-[-0.1px] font-montserratMedium';

export const getSignUpCtaClass = (styles, br) =>
  br
    ? FOOTER_YELLOW_CTA_BR
    : `${styles.button} bg-button font-montserratBold text-lg leading-[22px] tracking-[-0.1px] text-light rounded-[54px] cursor-pointer`;

export const getGiftCardSectionClass = (styles, br) =>
  br
    ? `${styles.sectionContainer} col-span-1`
    : `${styles.sectionContainer} col-span-1 flex flex-col items-center md:items-start md:justify-start justify-center gap-4 md:gap-8 md:text-left text-center`;

export const getGiftCardHeadingClass = (br) =>
  br ? BR_SECTION_HEADING_CLASS : 'font-montserratMedium text-lg leading-[22px] tracking-[-0.1px]';

export const getGiftCardBodyClass = (br) => (br ? 'm-0' : '');

export const getGiftCardLinkClass = (br) =>
  br ? '' : 'text-dryPink hover:bg-dark hover:bg-opacity-60 px-1 font-montserratMedium';

export const getGiftCardCtaClass = (styles, br) =>
  br
    ? FOOTER_YELLOW_CTA_BR
    : `${styles.button} bg-button font-montserratBold text-lg leading-[22px] tracking-[-0.1px] text-light h-[54px] rounded-[54px] w-[174px] cursor-pointer`;

export const getCopyrightClass = (styles, br) =>
  br
    ? `${styles.copyright} w-full text-center md:text-left font-brandRefreshFellix text-brandRefresh-bodyRegular text-brandRefresh-surface-onSurface mt-0`
    : `${styles.copyright} w-full text-center md:text-left`;

export const getSocialSectionClass = () =>
  'col-span-1 flex flex-col items-center md:items-end';

export const getStoreButtonClass = (br, widthClass = '') =>
  br
    ? 'focus-visible:outline focus-visible:outline-2 focus-visible:outline-brandRefresh-background-primary focus-visible:outline-offset-2'
    : `h-[54px] ${widthClass} rounded-[54px] py-3 bg-transparent border border-solid border-white text-white font-montserratBold`;
